import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppConnectComponent } from '../connect/connect.component';
import { AppSwitchComponent } from '../switch/switch.component';
import { AppChatSendComponent } from './send/send.component';
import { WidgetBoxComponent } from '../../widgets/box/box.component';
import { WidgetButtonComponent } from '../../widgets/button/button.component';
import { PipeAddress } from '../../pipes/address.pipe';
import { ChainHelper } from '../../helpers/chain.helper';
import { ModalHelper } from '../../helpers/modal.helper';
import { WalletHelper } from '../../helpers/wallet.helper';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  imports: [
    CommonModule,
    WidgetBoxComponent,
    WidgetButtonComponent,
    PipeAddress,
  ]
})
export class AppChatComponent implements OnInit, OnDestroy {

  /**
   * Chain helper
   */
  chain_helper = inject(ChainHelper);

  /**
   * Modal helper
   */
  modal_helper = inject(ModalHelper);

  /**
   * Wallet helper
   */
  wallet_helper = inject(WalletHelper);

  /**
   * Active account
   */
  active_account = computed(() => this.wallet_helper.active_account());

  /**
   * Sent events list
   */
  event_sents = signal<Array<any>>([]);

  /**
   * Whether action is loading
   */
  loading = signal(true);

  /**
   * Read events details task
   */
  private read_details_task: any;

  /**
   * Initialize component
   */
  ngOnInit() {
    this.startTasks();
  }

  /**
   * Destroy component
   */
  ngOnDestroy() {
    this.stopTasks();
  }

  /**
   * Start tasks
   */
  startTasks() {
    this.readDetails(true);
    this.read_details_task = setInterval(() => { this.readDetails(false) }, 3000);
  }

  /**
   * Stop tasks
   */
  stopTasks() {
    if (this.read_details_task) {
      clearInterval(this.read_details_task);
    }
  }

  /**
   * Open wallet modal
   */
  openWallet() {
    if (this.active_account()) {
      this.modal_helper.open(AppSwitchComponent, 'Manage Account', {});
    } else {
      this.modal_helper.open(AppConnectComponent, 'Connect Wallet', {});
    }
  }

  /**
   * Send message
   */
  send() {
    this.modal_helper.open(AppChatSendComponent, 'Send Message', {});
  }

  /**
   * Read events details
   * 
   * @param manual
   */
  async readDetails(manual: boolean) {
    // Enable loading mode when refreshed manually
    if (manual) {
      this.loading.set(true);
    }

    let events = await this.chain_helper.readEvents(0, 'ForumSentEvent');
    this.processSentEvents(events);

    this.loading.set(false);
  }

  /**
   * Process sent events
   * 
   * @param nodes 
   */
  processSentEvents(nodes: Array<any>) {
    let events = [];

    for (let i = 0; i < nodes.length; i++) {
      events.push({
        transaction: nodes[i].transactionBlock.digest,
        timestamp: nodes[i].timestamp,
        account: nodes[i].contents.json.account,
        message: nodes[i].contents.json.message,
      });
    }

    this.event_sents.set(events);
  }
}
